import { DefaultTheme, createGlobalStyle } from 'styled-components';
import { media } from 'ia-react-core';
import errorIcon from '../../../assets/error.svg';
import identifierIcon from '../../../assets/identifier.svg';
import visibilityIcon from '../../../assets/visibility.svg';
import visibilityOffIcon from '../../../assets/visibility-off.svg';
import rememberMeChecked from '../../../assets/rememberMeChecked.svg';
import rememberMeUnchecked from '../../../assets/rememberMeUnchecked.svg';

export const WidgetGlobalStyles = createGlobalStyle`
  html {
    touch-action: pan-x pan-y;
    height: 100%;
  }

  body {
    background: #fff !important;
  }

  body #app footer a {
    color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { linkWidget?: string } })?.awAuthentication?.linkWidget || theme.colors.link} !important;
  
    &:hover {
      color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { linkWidgetHover?: string } }).awAuthentication?.linkWidgetHover || theme.colors.link} !important;
    }
  }

  body #app footer button {
    color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { linkWidget?: string } })?.awAuthentication?.linkWidget || theme?.colors.light};
    
    &:hover {
      color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { mainHoverColor?: string } })?.awAuthentication?.mainHoverColor || theme?.colors.light};
      border-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { mainHoverColor?: string } })?.awAuthentication?.mainHoverColor || theme?.colors.light};
    }

    &:active {
      border-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { linkWidget?: string } })?.awAuthentication?.linkWidget || theme?.colors.light};
      color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { linkWidget?: string } })?.awAuthentication?.linkWidget || theme?.colors.light};
    }
  }

  #okta-sign-in.auth-container input[type=button], #okta-sign-in.auth-container input[type=submit],
  #okta-sign-in.auth-container .enroll-manual-push a.button-primary,
  #okta-sign-in.auth-container .auth-content-inner a.button-primary,
  #okta-sign-in.auth-container .auth-content .custom-password-expired a.button.button-primary.link-button,
  #okta-sign-in.auth-container .auth-content-inner .oie-enroll-webauthn a.button-primary
  {
    position: relative;
    display: inline-block;
    height: 50px;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    padding: 0 32px;
    border-radius: 25px;
    border: 0;
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.25);
    cursor: pointer;
    -webkit-appearance: none;
    line-height: 50px;
    text-decoration: none;
    outline: none;
    white-space: nowrap;
  
    &:hover {
      background: ${({ theme }) => theme.colors.light} !important;
    }
  
    &[disabled], &:disabled {
      background: ${({ theme }) => theme.colors.disabled} !important;
      font-style: ${({ theme }) => theme?.Button?.disabledFontStyle} !important;
      cursor: default;
    }
  
    &:focus {
      box-shadow: none !important;
    }
  
    &:focus, &:active  {
      background: ${({ theme }) => theme.colors.lighter} !important;
    }
  }

  #okta-sign-in.auth-container .primary-auth .okta-form-input-field,
  #okta-sign-in.auth-container .mfa-verify-password .okta-form-input-field,
  #okta-sign-in.auth-container .o-form-input-name-passCode.okta-form-input-field,
  #okta-sign-in.auth-container .mfa-verify .okta-form-input-field,
  #okta-sign-in.auth-container .oie-enroll-google-authenticator .okta-form-input-field
  {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    border-style: solid;
    border-width: 1px;
    font-size: ${({ theme }) => theme.fontSize.base}px;
    background: ${({ theme }) => theme.colors.white};
    appearance: none;
    outline: 0;
    padding: 9px 12px 8px 12px;
    border-radius: ${({ theme }) => theme?.Input?.borderRadius};
    font-family: ${({ theme }) => theme?.fontFamily?.regular};
    line-height: 18px;
    border-color: ${({ theme }) => theme?.Input?.borderColor || theme.colors.mediumGray};
  
    :not([disabled]), :not(:disabled) {
      :hover {
          border-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { inputHoverColor?: string } })?.awAuthentication?.inputHoverColor || theme?.colors.light};
      }
    }

    [disabled], :disabled {
      background: ${({ theme }) => theme.colors.gray1};
      font-style: ${({ theme }) => theme?.Input?.disabledFontStyle};
      color: ${({ theme }) => theme?.Input?.disabledColor};
    }
  }

  #okta-sign-in.auth-container .oie-enroll-google-authenticator .okta-form-input-field.o-form-disabled {
    background: ${({ theme }) => theme.colors.gray1};
    font-style: ${({ theme }) => theme?.Input?.disabledFontStyle};
    color: ${({ theme }) => theme?.Input?.disabledColor};
  }

  #okta-sign-in .o-form-explain.o-form-input-error
  {
    color: #d93934;
    display: none;
    padding-left: 18px;
    position: relative;
    word-break: break-word !important;
  }

  #okta-sign-in.auth-container .okta-form-input-field.input-fix 
  {
    border-color: #7F7F7F;
  }

  #okta-sign-in.auth-container .okta-form-input-field.input-fix:hover
  {
    border-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { inputHoverColor?: string } })?.awAuthentication?.inputHoverColor || ''};
  }


  #okta-sign-in.auth-container input[type=text],
  #okta-sign-in.auth-container input[type=tel], 
  #okta-sign-in.auth-container input[type=password]
  {
    color: ${({ theme }) => theme?.colors.text} !important;
  }

  #okta-sign-in.auth-container .primary-auth .input-fix input[type=text],
  #okta-sign-in.auth-container .primary-auth .input-fix input[type=password],
  #okta-sign-in.auth-container .mfa-verify .input-fix input[type=text],
  #okta-sign-in.auth-container .mfa-verify .input-fix input[type=tel]
  {
    padding: 0;
  }

  #okta-sign-in.auth-container .mfa-verify-password .input-fix input[type=password],
  #okta-sign-in.auth-container .mfa-verify-password .input-fix input[type=text]
  {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0;
  }

  #okta-sign-in.auth-container .okta-form-input-field.focused-input,
  #okta-sign-in.auth-container .okta-form-input-field:focus
  {
    outline: none;
    border-color: ${({ theme }) => theme?.colors.blue10} !important;
    border: solid 2px ${({ theme }) => theme?.colors.blue10};
    padding: 9px 12px 8px 12px;;
  }

  #okta-sign-in .focused-input, 
  #okta-sign-in input[type=text]:focus,
  #okta-sign-in input[type=radio]:focus+label,
  #okta-sign-in .link.help:focus
  {
    box-shadow: none !important;
  }

  #okta-sign-in.auth-container .input-fix.okta-form-input-field.o-form-has-errors
  {
    border: solid 2px ${({ theme }) => theme?.colors.error};
    border-color: ${({ theme }) => theme?.colors.error};
    :hover {
      border-color: ${({ theme }) => theme?.colors.error};
    }
  }

  #okta-sign-in.auth-container .okta-form-input-error.o-form-explain
  {
    color: ${({ theme }) => theme?.colors.error};
    font-weight: 600;
  }

  #okta-sign-in.auth-container .okta-form-input-error.o-form-explain .error-16-small::before
  {
    background-color: ${({ theme }) => theme?.colors.error};
    mask-image: url(${errorIcon});
    mask-size: cover;
    height: 18px;
    width: 18px;
    content: '';
  }

  #okta-sign-in .password-toggle .visibility-16::before
  {
    background-color: ${({ theme }) => theme.colors.light};
    mask-image: url(${visibilityIcon});
    mask-size: cover;
    height: 24px;
    width: 24px;
    content: '';
  }

  #okta-sign-in .password-toggle .visibility-off-16::before
  {
    background-color: ${({ theme }) => theme.colors.light};
    mask-image: url(${visibilityOffIcon});
    mask-size: cover;
    height: 24px;
    width: 24px;
    content: '';
  }

  #okta-sign-in.auth-container .o-form-input-name-password.input-fix .password-with-toggle
  {
    padding-right: 35px !important;
    width: 92%;
  }

  #okta-sign-in.auth-container .o-form .input-fix .password-toggle .eyeicon
  {
    right: 8px;
    padding: 4px 2px;
    opacity: 1;
  }

  #okta-sign-in.auth-container .o-form .input-fix .password-toggle .eyeicon::before
  {
    background-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { mainColor?: string } })?.awAuthentication?.mainColor || ''};
  }

  #okta-sign-in.auth-container .o-form .input-fix .password-toggle .eyeicon:hover:before
  {
    background-color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { mainHoverColor?: string } })?.awAuthentication?.mainHoverColor || ''};
  }

  #okta-sign-in.auth-container .o-form-label label
  {
    font-weight: bold;
    line-height: 1.29;
  }

  #okta-sign-in span.registration-label
  {
    display: none !important;
  }

  #okta-sign-in .o-form .custom-checkbox
  {
    padding-top: 8px;
  }

  #okta-sign-in .o-form .custom-checkbox label
  {
    font-size: ${({ theme }) => theme.fontSize.base}px !important;
    padding-left: 28px;
  }

  #okta-sign-in.auth-container .o-form-content.o-form-theme.clearfix
  {
    padding-bottom: 32px;
  }

  #okta-sign-in .auth-footer a.link, 
  #okta-sign-in.auth-container a.inline-link,
  #okta-sign-in.auth-container .scan-instructions-qrcode-wrapper .link,
  #okta-sign-in.auth-container .mfa-verify a.link,
  #okta-sign-in .okta-custom-buttons-container a.link,
  #okta-sign-in .primary-auth-container a.link,
  #okta-sign-in .oie-enroll-google-authenticator .qrcode-info-container a.cannot-scan-link,
  #okta-sign-in .oie-enroll-ov-poll .switch-channel-link
  {
    text-decoration: none;
    color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { linkWidget?: string } }).awAuthentication?.linkWidget || theme.colors.link} !important;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.29;
    background: transparent;
    border: 0;
    padding: 0;
    outline: 0;
    text-align: left;
  
    &:hover, &:focus, &:active {
      text-decoration: underline;
      cursor: pointer;
      color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { linkWidgetHover?: string } }).awAuthentication?.linkWidgetHover || theme.colors.link} !important;
    }

    &:visited {
      color: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { linkWidget?: string } }).awAuthentication?.linkWidget || theme.colors.light};
    }
  }

  #login-widget
  {
    padding-bottom: 0px;
    ${media.sm`
      padding-bottom: 200px;
    `}
  }

  #okta-sign-in .beacon-container
  {
    top: 35px;
  }

  #okta-sign-in.no-beacon .auth-content
  {
    padding-bottom: 0;
  }

  #okta-sign-in.no-beacon .auth-content .custom-password-expired
  {
    padding-top: 16px;
    padding-bottom: 8px;
  }

  #okta-sign-in.auth-container .custom-password-expired .o-form-content.o-form-theme.clearfix
  {
    padding-bottom: 0;
  }

  #okta-sign-in.auth-container .custom-password-expired .okta-form-subtitle
  {
    margin-bottom: 36px;
  }

  #okta-sign-in.auth-container .custom-password-expired .auth-footer a.link 
  {
    display: none;
  }

  #okta-sign-in .o-form .infobox.infobox-error
  {
    padding: 24px 16px 24px 65px !important;
    background-color: #fdeded;
    border-radius: 4px;
    border: solid 1px ${({ theme }) => theme?.colors.error};
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 36px;
  }

  #okta-sign-in .auth-content .mfa-verify-password .o-form-content .okta-form-infobox-error.infobox.infobox-error
  {
    margin-bottom: 29px;
  }

  #okta-sign-in .o-form .infobox::before
  {
    display: none;
  }

  #okta-sign-in .o-form .infobox .icon
  {
    position: absolute;
    display: inline-block;
    float: left;
    top: 50%;
    margin-top: -24px;
  }

  #okta-sign-in .o-form .infobox .icon.error-16:before,
  #okta-sign-in .o-form .infobox .icon.error-24:before
  {
    position: relative;
    background-color: ${({ theme }) => theme?.colors.error};
    mask-image: url(${errorIcon});
    mask-size: cover;
    height: 48px;
    width: 48px;
    content: '';
  }

  @media only screen and (max-width: 600px)
  {
    #okta-sign-in .o-form .infobox .icon
    {
      float: none;
    }

    #okta-sign-in .o-form .infobox .icon.error-16:before,
    #okta-sign-in .o-form .infobox .icon.error-24:before
    {
      bottom: 0;
    }

    #okta-sign-in.auth-container .auth-footer a.link.js-switchAuthenticator,
    #okta-sign-in.auth-container .oie-enroll-ov-data input[type="submit"] 
    {
      font-size: 12px !important;
    }
  }

  @media only screen and (max-width: 400px)
  {
    #okta-sign-in.auth-container .auth-footer a.link.js-switchAuthenticator
    {
      font-size: 9px !important;
    }
  }
  
  #okta-sign-in * {
    color: ${({ theme }) => theme.colors.text};
    font-family: ${({ theme }) => theme.fontFamily.regular} !important;
  }

  #okta-sign-in .auth-header {
    display: none;
  }
  
  #okta-sign-in.no-beacon .auth-header {
    padding: 0px 0px 0px 0px !important;
  }

  #okta-sign-in.auth-container.main-container {
    border-width: 0;
    box-shadow: none !important;
    width: 100%;
    max-width: 560px;
    border-radius: 0 0 4px 4px;
    margin: auto;
    outline: none;
    overflow: hidden;
  }

  #okta-sign-in .primary-auth .okta-form-title {
    display: none;
  }

  #okta-sign-in .enroll-choices .o-form-head,
  #okta-sign-in .okta-form-title.o-form-head
  {
    display: none;
  }

  #okta-sign-in.auth-container .enroll-choices .o-form-explain.okta-form-subtitle
  {
    padding: 4px 0px 24px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray4};
  }

  #okta-sign-in.auth-container .enroll-choices .enroll-factor-label span.icon.success-16-green:before {
    color: ${({ theme }) => theme.colors.primary};
  }

  #okta-sign-in.auth-container .o-form-explain.okta-form-subtitle, 
  #okta-sign-in.auth-container .enroll-factor-description h3
  {
    text-align: left;
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
    font-weight: bold;
  }

  #okta-sign-in.auth-container .enroll-factor-description p
  {
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
  }

  #okta-sign-in.auth-container .enroll-factor-row .enroll-factor-button a,
  #okta-sign-in.auth-container a.button.link-button
  {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    line-height: 1.29;
    height: auto;
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.25);
    padding: 11px 16px;
    border-radius: 4px;
    border: 0;
    text-decoration-line: none;

    &:hover {
      background: ${({ theme }) => theme.colors.light};
    }

    &:focus, &:active  {
      background: ${({ theme }) => theme.colors.lighter};
    }
  }

  #okta-sign-in .scan-instructions .scan-instructions-details-wrapper .scan-instructions-details
  {
    margin-bottom: 20px;
  }

  #okta-sign-in .barcode-scan .scan-instructions .scan-instructions-details-wrapper,
  #okta-sign-in .barcode-scan .scan-instructions .scan-instructions-qrcode-wrapper
  {
    float: none;
  }

  #okta-sign-in.auth-container .qrcode-wrap .qrcode-image
  {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  #okta-sign-in.auth-container .o-form-fieldset-container .o-form-input-name-phoneNumber span,
  .chzn-container .chzn-single span,
  .chzn-container .chzn-results .active-result
  {
    color: ${({ theme }) => theme.colors.text} !important;
    font-family: ${({ theme }) => theme.fontFamily.regular} !important;
    font-size: 14px !important;
  }

  #okta-sign-in.auth-container .enroll-manual-push .o-form-fieldset-container .chzn-single,
  #okta-sign-in.auth-container .o-form-input-name-phoneNumber .okta-form-label-inline
  {
    border-color: #7f7f7f;
  }

  #okta-sign-in .o-form .o-form-input-name-sharedSecret.input-fix input[disabled]
  {
    background: #eff1f4;
    color: ${({ theme }) => theme.colors.text};
    -webkit-text-fill-color: ${({ theme }) => theme.colors.text};
  }

  #okta-sign-in .o-form .o-form-input-name-sharedSecret.input-fix.o-form-disabled
  {
    opacity: 1;
  }

  #okta-sign-in .enroll-activation-link-sent p,
  #okta-sign-in .webauthn-enroll-instructions p,
  #okta-sign-in .enroll-email .o-form-fieldset-container div
  {
    font-weight: bold;
  }

  #okta-sign-in.auth-container .auth-content
  {
    padding-left: 32px;
    padding-right: 32px;
    padding-top: 0px !important;
    padding-bottom: 20px;
    max-width: none;
  }

  #okta-sign-in.auth-container .primary-auth .okta-form-label.o-form-label,
  #okta-sign-in.auth-container .idp-discovery .okta-form-label.o-form-label
  {
    padding-top: 36px;
    padding-bottom: 12px;
  }

  #okta-sign-in.auth-container .auth-content .enroll-sms
  {
    padding-top: 16px;
  }

  #okta-sign-in.auth-container .auth-content .enroll-sms .okta-form-infobox-error.infobox.infobox-error
  {
    margin-bottom: 20px;
    margin-top: 0px;
  }

  #okta-sign-in.auth-container .o-form-fieldset.o-form-label-top
  {
    margin-bottom: 0 !important;
  }

  #okta-sign-in.auth-container .o-form-button-bar
  {
    padding-bottom: 8px;
  }

  #okta-sign-in .auth-footer a.link.goto,
  #okta-sign-in .auth-footer a.link.js-back,
  #okta-sign-in a.btn-registration,
  #okta-sign-in .auth-footer a.link.js-switchAuthenticator,
  #okta-sign-in a.link.phone-authenticator-challenge__link
  {
    position: relative;
    display: inline-block !important;
    height: 50px !important;
    font-size: 17px !important;
    font-weight: bold;
    text-align: center !important;
    background: transparent;
    color: ${({ theme }) => theme.colors.primary} !important;
    padding: 0 32px;
    border-radius: 25px !important;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    -webkit-appearance: none;
    box-sizing: border-box !important;
    line-height: 46px !important;
    text-decoration: none !important;
    outline: none;
    white-space: nowrap;
    width: 100%;
  
    &:hover {
      color: ${({ theme }) => theme.colors.light} !important;
      border-color: ${({ theme }) => theme.colors.light};
      background-color: transparent;
    }
  
    &:active, &:focus {
      color: ${({ theme }) => theme.colors.lighter};
      border-color: ${({ theme }) => theme.colors.lighter};
      background-color: transparent;
    }
  }

  #okta-sign-in.auth-container .okta-custom-buttons-container a.link,
  #okta-sign-in.auth-container .primary-auth-container a.link,
  #okta-sign-in .primary-auth-container a.link.default-custom-button.link-button
    {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray4};
    margin-top: 36px;
    margin-bottom: 36px;
    border-radius: 0px;
    padding-bottom: 36px;
    height: 100%;
  }

  #okta-sign-in.auth-container .registration-container {
    margin-top: 36px;
  }

  #okta-sign-in.auth-container .registration-container .content-container {
    padding-top: 36px;
    padding-bottom: 36px;
  }

  #okta-sign-in .auth-footer .help,
  #okta-sign-in .auth-footer .js-help {
    display: none !important;
  }

  #okta-sign-in .auth-footer {
    display: block !important;
  }

  #okta-sign-in .auth-footer a.link {
    display: block;
    margin-top: 16px;
  }

  #okta-sign-in .auth-footer .js-back {
    display: block !important;
  }

  #okta-sign-in input[type=password]::-ms-reveal,
  #okta-sign-in input[type=password]::-ms-clear
  {
      display: none;
  }

  #okta-sign-in .o-form .custom-checkbox label {
    background:url(${rememberMeUnchecked}) no-repeat left center !important;
    height: auto;
  }

  #okta-sign-in .o-form .custom-checkbox label.checked {
    background:url(${rememberMeChecked}) no-repeat left center !important;
  }
  
  #okta-sign-in.auth-container .siw-main-body .identifier-container:before {
    background-color: ${({ theme }) => theme.colors.teal7};
    mask-image: url(${identifierIcon});
    mask-size: cover;
    height: 24px;
    width: 24px;
    content: '';
    padding-right: 24px;
    margin-right: 8px;
    padding-bottom: 5px;
    vertical-align: 7%;
  }

  #okta-sign-in.auth-container .siw-main-body .identifier-container {
    font-weight: bold;
    line-height: 1.29;
    text-align: left;
    top: 0px;
  }

  #okta-sign-in.auth-container .siw-main-body .identifier-container .identifier {
    font-size: 14px !important;
    line-height: 24px;
  }

  #okta-sign-in.auth-container .oie-enroll-ov-data .switch-channel-text  {
    margin: 0;
  }

  #okta-sign-in.auth-container .separation-line {
      display: none;
  }

  #okta-sign-in .auth-divider {
    display: none;
  }

  #okta-sign-in .oie-enroll-google-authenticator .google-authenticator-setup-info-title {
    text-align: left;
    font-weight: bold;
    line-height: 1.29;
  }

  #okta-sign-in .oie-enroll-google-authenticator .google-authenticator-next.default-custom-button,
  #okta-sign-in .oie-enroll-google-authenticator .google-authenticator-verify.default-custom-button.button-primary.link-button 
  {
    margin-bottom: 0;
  }

  #okta-sign-in .oie-enroll-google-authenticator .qrcode-info-container,
  #okta-sign-in .oie-enroll-google-authenticator .oie-enroll-google-authenticator-manual-setup, 
  #okta-sign-in .oie-enroll-google-authenticator .google-authenticator-setup-info-title.enter-code-title,
  #okta-sign-in .oie-enroll-webauthn .idx-webauthn-enroll-text,
  #okta-sign-in .oie-enroll-ov-poll .qrcode-info.ov-info,
  #okta-sign-in .oie-enroll-ov-poll .infobox.infobox-warning,
  #okta-sign-in .ion-form .o-form-fieldset-container,
  #okta-sign-in .phone-authenticator-enroll .infobox.infobox-warning
  {
    display: block;
    font-weight: bold;
    line-height: 1.29;
  }

  #okta-sign-in .oie-enroll-google-authenticator .google-authenticator-setup-info,
  #okta-sign-in .oie-enroll-google-authenticator .qrcode-container .qrcode
  {
    margin-bottom: 15px;     
  }

  #okta-sign-in.auth-container .primary-auth .o-form-content.o-form-theme.clearfix {
    padding-top: 0px;
  }

  #okta-sign-in a:active, 
  #okta-sign-in a:link, 
  #okta-sign-in a:visited {
    text-decoration: none;
  }

  #okta-sign-in a:focus, 
  #okta-sign-in a:hover {
    text-decoration: underline;
  }

  #okta-sign-in.auth-container .barcode-totp .scan-instructions-details {
    padding: 0px;
  }

  #okta-sign-in.auth-container .enroll-totp .o-form-label legend, 
  #okta-sign-in.auth-container .barcode-totp .scan-instructions-details p {
    color: ${({ theme }) => theme.colors.text};
    font-weight: bold;
  }

  #okta-sign-in.auth-container .enroll-totp .o-form-content.o-form-theme.clearfix {
    padding-bottom: 0px;
  }

  #okta-sign-in.auth-container .enroll-totp .o-form-fieldset-container a.button.link-button {
    font-size: 17px;
    margin-bottom: 0px;
    border-radius: 25px;
    line-height: 46px;
    padding: 0px 32px;
  }

  #okta-sign-in.auth-container .enroll-totp .custom-radio label {
    background: url('https://op3static.oktacdn.com/assets/js/sdk/okta-signin-widget/7.11.0/img/ui/forms/radiobutton-01-a11y.png') no-repeat;
    background-position: -16px -13px;
  }

  #okta-sign-in.auth-container .enroll-totp .custom-radio label.hover,
  #okta-sign-in.auth-container .enroll-totp .custom-radio label.focus {
    background-position: -16px -113px;
  }

  #okta-sign-in.auth-container .enroll-totp .custom-radio label.checked {
    background-position: -16px -213px;
  }

  #okta-sign-in.auth-container .enroll-manual-totp .auth-footer a.link.help.goto.js-goto {
    display: none !important;
  }

  #okta-sign-in.auth-container .enroll-sms .o-form-content .o-form-fieldset.o-form-label-top input[type="tel"][name="passCode"],
  #okta-sign-in.auth-container .activate-totp .o-form-content .o-form-fieldset.o-form-label-top input[type="tel"][name="passCode"] {
    padding: 0px;
  }

  #okta-sign-in.auth-container .enroll-sms .o-form-content .o-form-fieldset.o-form-label-top.enroll-sms-phone {
    margin-top: 10px;
  }

  #okta-sign-in.auth-container .mfa-verify .o-form-content a.button.sms-request-button.link-button {
    margin-top: 20px;
  }

  #okta-sign-in.auth-container .enroll-sms .o-form-content a.button.js-enroll-phone.margin-top-30.sms-request-button.link-button {
    margin-top: 25px;
  }

  #okta-sign-in.auth-container .enroll-sms .o-form-content a.button.button-primary.js-enroll-phone.margin-top-30.sms-request-button.link-button,
  #okta-sign-in.auth-container .enroll-sms .o-form-content 
    a.button.js-enroll-phone.margin-top-30.sms-request-button.link-button.link-button-disabled.btn-disabled.disabled {
    margin-top: 40px;
  }

  #okta-sign-in.auth-container .mfa-verify span.icon.warning-16,
  #okta-sign-in.auth-container .enroll-sms span.icon.warning-16 {
    display: none;
  }

  @media (max-width: 600px) {
    #okta-sign-in.auth-container .mfa-verify .auth-footer.clearfix a.link.goto {
      font-size: 3vw !important;
    }
  }

  #okta-login-container .auth-content .auth-content-inner .siw-main-view.keep-me-signed-in p.okta-form-subtitle.o-form-explain {
    font-weight: normal !important;
  }

  #okta-login-container .auth-content .auth-content-inner .siw-main-view.enroll-authenticator--phone_number.enroll-sms div.okta-form-subtitle {
    font-weight: bold;
    color: #1b1b1b;
    margin-top: 15px;
  }

  #okta-login-container .auth-content .auth-content-inner .siw-main-view.keep-me-signed-in a.button.button-secondary.link-button,
  #okta-login-container .auth-content .auth-content-inner .siw-main-view.select-authenticator-enroll.enroll-choices a.button-primary.button.skip-all.link-button {
    border-radius: ${({ theme }) => theme?.Button?.borderRadius};
  }

  #okta-login-container .auth-content .auth-content-inner .siw-main-view.keep-me-signed-in a.button.button-secondary.link-button[data-se='do-not-stay-signed-in-btn'] {
    color: ${({ theme }) => theme.colors.primary}!important;
    background: ${({ theme }) => theme.colors.transparent};
    border: 2px solid ${({ theme }) => theme.colors.primary};
  }

  /* Styles pour la liste des MFA oie (Dealers) */
  @media only screen and (max-width: 450px)
  {
    #okta-sign-in.auth-container .authenticator-verify-list .authenticator-row
    {
      display: flex;
      flex-wrap: nowrap;
    }
    
    #okta-sign-in.auth-container .authenticator-verify-list .authenticator-row .authenticator-icon-container
    {
      display: flex;
      align-self: center;
      flex-wrap: inherit;
    }
    
    #okta-sign-in.auth-container .authenticator-verify-list .authenticator-description .authenticator-label,
    #okta-sign-in.auth-container .authenticator-verify-list .authenticator-description .authenticator-description--text,
    #okta-sign-in.auth-container .authenticator-verify-list .authenticator-description .authenticator-button 
    {
      width: auto;
    }

    #okta-sign-in.auth-container .authenticator-verify-list .authenticator-description>div
    {
      width: 130px;
    }
  }

  @media only screen and (max-width: 400px)
  {
    #okta-sign-in.auth-container .authenticator-verify-list .authenticator-description>div
    {
      width: 90px;
    }
    
    #okta-sign-in.auth-container .authenticator-verify-list .authenticator-row .authenticator-icon-container
    {
      margin-right: 10px;
    }
    
    #okta-sign-in.auth-container .authenticator-verify-list .factor-icon.authenticator-icon.mfa-okta-verify, #okta-sign-in.auth-container .authenticator-verify-list .factor-icon.authenticator-icon.mfa-okta-password, #okta-sign-in.auth-container .authenticator-verify-list .factor-icon.authenticator-icon.mfa-okta-phone
    {
      height: 30px;
      width: 30px;
      background-size: 30px 30px;
    }
    
    #okta-sign-in.auth-container .authenticator-verify-list .authenticator-description .authenticator-button
    {
      width: 90px;
    }
    
    #okta-sign-in.auth-container .authenticator-verify-list a.button.link-button
    {
      font-size: 10px;
    }
  }
  
  #okta-sign-in .mfa-sms-30,
  #okta-sign-in .mfa-call-30,
  #okta-sign-in .mfa-email-30,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-okta-verify,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-google-auth,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-okta-sms,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-okta-call,
  #okta-sign-in .factor-icon.enroll-factor-icon.mfa-okta-email {
    border-radius: 0 !important;
    border: none !important;
  }

  #okta-sign-in div.auth-beacon-factor,
  #okta-sign-in div.beacon-blank.auth-beacon {
    display: none;
  }

  #okta-sign-in div.enroll-sms div.okta-form-subtitle span{
    margin: -2px;
  }
`;
